function formatFileSize(bytes) {
	if (!bytes) return ''

	const kb = bytes / 1024

	if (kb < 1024) {
		return `${Math.round(kb)} KB`
	}

	return `${(kb / 1024).toFixed(1).replace('.', ',')} MB`
}

export function fileSize() {
	document.querySelectorAll('[data-file-size]').forEach((el) => {
		const url = el.dataset.fileSize

		if (!url) return

		fetch(url, { method: 'GET' })
			.then((response) => {
				const length = response.headers.get('Content-Length')

				if (!length) {
					console.warn('fileSize: no Content-Length header for', url, response)
					return
				}

				const formatted = formatFileSize(parseInt(length, 10))

				if (formatted) {
					el.textContent += ` • ${formatted}`
				}
			})
			.catch((error) => {
				console.warn('fileSize: fetch failed for', url, error)
			})
	})
}
